import { render, staticRenderFns } from "./CatalogToggler.vue?vue&type=template&id=dcc4b70c"
import script from "./CatalogToggler.vue?vue&type=script&lang=js"
export * from "./CatalogToggler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports